/*
 * Smooth scrolling to a HTMLElement
 */
import scrollTo from 'nespresso-library/src/utils/scrollTo'
import { position } from 'gaspard'
export default function goToSmooth (ref, minus = 0, duration = 325) {
    let element
    if (ref instanceof HTMLElement) {
        element = ref
    } else {
        element = document.querySelector(ref)
    }

    scrollTo(position(element).top - minus, duration)
}



// WEBPACK FOOTER //
// ./node_modules/gvue/src/assets/js/mixins/scrollTo.js